module.exports = __webpack_public_path__ + "static/media/dribbble.8f2d0d70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/socials/dribbble.svg
// module id = 199
// module chunks = 0